import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
const promises = ['Devolución del 100% de tu dinero', 'Sin formularios', 'Sin drama', 'Sin explicaciones'];
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="border-y border-ink-600 bg-ink-800" data-id="element-95" data-mp="9tbe8wppooia">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:py-20" style={{
      paddingTop: "9px",
      paddingBottom: "10px"
    }} data-id="element-96" data-mp="etpo8kavi8iy">
        <div data-id="element-97" data-mp="jsaebqwevbto">
          <h2 id="garantia" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" style={{
          paddingTop: "20px"
        }} data-id="element-98" data-mp="jqpuav7q3ba2">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-300" data-id="element-99" data-mp="sn6w37u75wt5">
            Abre el material. Úsalo en la cancha. Si en 7 días no es exactamente lo que esperabas:
          </p>

          <ul className="mx-auto mt-6 grid max-w-xl gap-3 sm:grid-cols-2" data-id="element-100" data-mp="12kuzsn9s6eng">
            {promises.map(promise => <li key={promise} className="flex items-center justify-center gap-3 text-[15px] text-slate-200" data-id="element-101" data-mp="17g0mvpex5zd4">
                <CheckIcon className="h-5 w-5 shrink-0 text-ball-400" strokeWidth={3} aria-hidden="true" data-id="element-102" data-mp="25pkjpp1mvhbw" />
                {promise}
              </li>)}
          </ul>

          <p className="mt-8 text-base font-semibold text-white" data-id="element-103" data-mp="1vu9dxw87dkga">
            Nosotros asumimos todo el riesgo. Tú no tienes nada que perder.
          </p>
          <p className="mt-2 text-sm text-slate-500" data-id="element-104" data-mp="2oi556lf06k5o">
            Tasa de devoluciones Sigma Smart: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}